var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33334 3.33341C5.57191 3.33341 3.33334 5.57199 3.33334 8.33342C3.33334 11.0948 5.57191 13.3334 8.33334 13.3334C11.0948 13.3334 13.3333 11.0948 13.3333 8.33342C13.3333 5.57199 11.0948 3.33341 8.33334 3.33341ZM1.66667 8.33342C1.66667 4.65152 4.65144 1.66675 8.33334 1.66675C12.0152 1.66675 15 4.65152 15 8.33342C15 9.87401 14.4774 11.2925 13.5999 12.4215L18.0893 16.9108C18.4147 17.2363 18.4147 17.7639 18.0893 18.0893C17.7638 18.4148 17.2362 18.4148 16.9107 18.0893L12.4214 13.6C11.2925 14.4775 9.87393 15.0001 8.33334 15.0001C4.65144 15.0001 1.66667 12.0153 1.66667 8.33342Z",
    fill: "#196AAB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bc6efa9641088b1de9231a419945a1eb.svg";
export { ForwardRef as ReactComponent };